// extracted by mini-css-extract-plugin
export default {"tabs_container":"TabsNew_tabs_container__jYUEH","tab":"TabsNew_tab__yR2Vq"};